import * as React from 'react';
import { MyAppBar } from "../components/Home/MyAppBar/myAppBar";
import { Alert, Container } from "@mui/material";
import { useContext, useState, useCallback } from 'react';
import { LoadingCircle } from '../components/loading';
import { AuthContext } from '../contexts/authContext';
import { ProfileDetails } from '../components/User/Profile/profileDetails';
import Snackbar from '@mui/material/Snackbar';
import { UserAppBar } from '../components/User/userAppBar';

export const User = () => {
    const { user, userProfile, profileLoading, saveUserProfile } = useContext(AuthContext);
    const [notification, setNotification] = useState({ open: false, severity: "success", message: "" });

    const showNotification = useCallback((severity, message) => {
        setNotification({ open: true, severity, message });
    }, []);

    const handleCloseNotification = useCallback((event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setNotification(prev => ({ ...prev, open: false }));
    }, []);

    // Double check what saveProfile receives from ProfileDetails.
    // If userData is undefined, it might mean ProfileDetails is not passing the form data properly.
    // Ensure that on the submit event of the form, the actual form values are being sent to saveProfile.
    //
    // For debugging, let's log the received data:
    const saveProfile = useCallback(async (userData) => {
        if (!userData) {
            showNotification("error", "No user data provided from form");
            return;
        }
        try {
            await saveUserProfile(userData);
            showNotification("success", "Profile updated successfully");
        } catch (error) {
            console.error("Error saving profile:", error);
            showNotification("error", "Failed to save profile");
        }
    }, [saveUserProfile, showNotification]);

    if (profileLoading) {
        return (
            <>
                <MyAppBar />
                <Container maxWidth="md">
                    <LoadingCircle />
                </Container>
            </>
        );
    }

    if (!userProfile) {
        return (
            <>
                <MyAppBar />
                <Container maxWidth="md">
                    <h1>No profile data found</h1>
                </Container>
            </>
        );
    }

    return (
        <>
            <UserAppBar userData={userProfile} />
            <ProfileDetails
                userData={userProfile}
                email={user.email}
                uid={user.uid}
                saveProfile={saveProfile}
            />
            <Snackbar
                open={notification.open}
                autoHideDuration={3000}
                onClose={handleCloseNotification}
            >
                <Alert
                    onClose={handleCloseNotification}
                    severity={notification.severity}
                    sx={{ width: '100%' }}
                >
                    {notification.message}
                </Alert>
            </Snackbar>
        </>
    );
};